import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { SearchInputComponent } from './search-input.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SearchInputComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [SearchInputComponent],
})
export class SearchInputModule {}
